"use strict";
var ACC;
ACC.mobileapp = {

    _autoload: [
		"messageChannelMobileApp"
	],

    messageChannelMobileApp: function() {
        const isMobileApp = typeof TKMaxxWebView !== 'undefined';

        if(ACC.isMobileApp) {
            const url = `${window.ACC.config.encodedContextPath}/appLoginEvent/getEvents`;
            const headers = {
                'content-type': 'text/plain',
                'X-Requested-With': 'XMLHttpRequest'
            };

            fetch(url, {
                method: 'GET',
                headers: headers
            })
            .then(response => response.json())
            .then(events => {
                // the BE response (events) should always return an array of obects representing the event data
                // that will be passed
                if (Array.isArray(events) && events.length > 0) {

                    events.forEach(function(event) {
                        if (isMobileApp) {
                            // Send each event to the mobile app
                            TKMaxxWebView.postMessage(`${JSON.stringify(event)}`);
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching events:', error);
            });
        }
    }
};